import { useLogoutMutation } from '@api/api';
import { LogoutResponse } from '@api/types';
import { Button, ButtonProps } from '@components';
import { useAuth } from '@hooks';
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { useNavigate } from 'react-router-dom';

type LogoutButtonProps = ButtonProps & {
  onLogoutSuccess?: () => void;
};
export const LogoutButton = ({ onLogoutSuccess, ...props }: LogoutButtonProps) => {
  const { isAuthenticated } = useAuth();
  const [trigger, response] = useLogoutMutation();
  const { isLoading } = response;
  const navigate = useNavigate();

  const logout = () => {
    onLogoutSuccess?.();
    trigger().then(
      (res: { data: LogoutResponse } | { error: FetchBaseQueryError | SerializedError }) => {
        if ('data' in res && res.data.status === 200) {
          navigate(res.data?.data?.redirectUrl ?? '/');
        }
      }
    );
  };

  return isAuthenticated ? <Button {...props} onClick={logout} busy={isLoading} /> : null;
};
